import type { CustomFile } from '../../types';
import type { TypeGroupedFilesResult } from '../../utils/groupFilesByRootFolderOrSingle';

import * as exUploadUtils from '../../utils';

// ----------------------------------------------------------------------------

export type TypeUploadItemsData = TypeGroupedFilesResult[string] & { title: string };

// ----------------------------------------------------------------------------

function prepareUploadItemsData(files: CustomFile[]): TypeUploadItemsData[] {
    const groupedFiles = exUploadUtils.groupFilesByRootFolderOrSingle(files);

    /*
     * The title is the group's display name, not its key: the key is disambiguated when a folder
     * and a loose file share a name, and that suffix is bookkeeping the user should not see.
     */
    return Object.values(groupedFiles).map((group) => ({ ...group, title: group.name }));
}

// ----------------------------------------------------------------------------

export default prepareUploadItemsData;
